import type { EventRow } from "./api";

export const EVENT_TYPE_LABELS: Record<EventRow["event_type"], string> = {
  opening_balance: "Opening balance",
  purchase_intake: "Intake",
  production_pull: "Production pull",
  stock_take_adjustment: "Stock take",
  disposal: "Removed",
  void: "Void",
};

export type LogFilters = {
  event_type: string | null;
  factory: string | null;
  sku: string | null;
  from: string | null;
  to: string | null;
  discrepancies: boolean;
};

export function filterLog(rows: EventRow[], filters: LogFilters): EventRow[] {
  return rows.filter((row) => {
    if (filters.event_type && row.event_type !== filters.event_type) return false;
    if (filters.factory && row.factory_id !== filters.factory) return false;
    if (filters.sku && row.xero_item_code !== filters.sku) return false;
    const day = row.occurred_at.slice(0, 10);
    if (filters.from && day < filters.from) return false;
    if (filters.to && day > filters.to) return false;
    if (filters.discrepancies && row.event_type !== "stock_take_adjustment" && row.event_type !== "void") return false;
    return true;
  });
}

export function rowValueDelta(row: EventRow): number | null {
  if (row.unit_value_applied === null) return null;
  return Number(row.qty_delta) * (Number(row.unit_value_applied) + Number(row.inbound_cost_applied ?? "0"));
}
